import { createTheme } from '@mui/material';
import { fontFamily } from '@aib/design-tokens';

export const aibTheme = createTheme({
  palette: {
    contrastThreshold: 4.5,
    primary: {
      main: '#00856a',
      light: '#e2f7f3',
    },
    secondary: {
      light: '#cda4cd',
      main: '#7f2b7b',
      dark: '#690E6E',
      semilight: '#995595',
    },
    neutral: {
      disabled: '#6e6e6e',
      main: '#6f6675',
      contrastText: '#6f6675',
      dark: '#2c2c2c',
      semidark: '#4d4d4d',
      semilight: '#d9d9d9',
      light: '#e9e9e9',
      offWhite: '#f4f4f4',
      baseWhite: '#ffffff',
      mediumGrey: '#e2e2e2',
      gray: '#808080',
    },
    error: {
      main: '#e32837',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 600,
      lg: 800,
      xl: 1000,
    },
  },
  typography: {
    fontFamily: fontFamily.regular,
    mediumFontFamily: fontFamily.medium,
    boldFontFamily: fontFamily.bold,
  },
});

export type Theme = typeof aibTheme;
